<kendo-dropdownlist
  [data]="tiers"
  textField="name"
  valueField="id"
  (ngModelChange)="onTierSelected($event)"
  [(ngModel)]="selectedTier"
>
  <ng-template kendoDropDownListValueTemplate let-dataItem>
    <span class="selected-tier">
      <fa-icon
        class="lock-icon"
        *ngIf="selectedTier?.isLocked ?? false"
        [icon]="['fas', 'lock']"
      ></fa-icon>
      {{ dataItem?.name }} -
      <strong
        ><fa-icon
          class="king-icon icon-text"
          [icon]="['fas', 'crown']"
        ></fa-icon
        >{{ dataItem?.kingRestaurantName }}
      </strong></span
    >
  </ng-template>
</kendo-dropdownlist>
